// /////////////////////////////////////////////////////////////
// Sous Fichier pour la gestion des routes de localisation
// /////////////////////////////////////////////////////////////
// Creation : 18/03/2022    -> CGR
// /////////////////////////////////////////////////////////////



// ///////////////////////////////////
// Imports

// Imports system
import React from 'react';
import {
    Routes,
    Route
} from 'react-router-dom';
import Page404 from '../../../pages/page404/page404';

import { programmeContext } from '../../../contexts';

// Imports src
import Exterieurs from './../../../pages/exterieurs/exterieurs'


///////////////////////////////////
// Component

const ExterieursRouter = () => { // Routes pour le moteur de recherche

    // Render
    return (
        <programmeContext.Consumer>
            {datas => datas &&
                <Routes>
                    <Route path='' element={<Exterieurs/>} />
                    <Route path=':vue/:scene/:variante' element={<Exterieurs/>} />
                    <Route path=':vue/:variante' element={<Exterieurs/>} />
                    <Route path=':variante' element={<Exterieurs/>} />
                    <Route path='*' element={<Page404 />} />
                </Routes>
            }
        </programmeContext.Consumer>
    )
}


// ///////////////////////////////////
// Export
export default ExterieursRouter;